import { OutroServico } from "./outroServico";
import { DocumentoInicial } from "./documentoInicial";
import { CentralRelacionamento } from "./centralRelacionamento";
import { Parceiro } from "./parceiro";
import { ImagemRotativa } from "./imagemRotativa";

export class ConfiguracaoVisual {

    imgLogoIdentificacao: string;
    imgLogoPrincipal: string;
    cdIndcdPadraoBradesco: boolean;
    dsLogo: string;
    nuCorR: number;
    nuCorG: number;
    nuCorB: number;
    imgPrimeiroAcesso: string;
    imgFundoTela: string;
    imgCampanha: string;
    cdIndcdCampanha: boolean;
    cdIndcdPrimeiroAcesso: boolean;
    dtCampanhaDe: Date;
    dtCampanhaAte: Date;
    listaOutroServico: OutroServico[];
    listaDocumento: DocumentoInicial[];
    listaCentralRelacionamento: CentralRelacionamento[];
    listaImagemRotativaVisual: ImagemRotativa[];
    cdMsgemRetorno: string;
    dsMsgemRetorno: string;
    msgTextoAgradecimentoRedir: string;
    urlSiteDestinoRedir: string;
    imgBannerRedir: string;
    redirecionar: boolean;
    nmSiteDestinoRedir: string;
    nuQtdeTempoRedir: number;
    parceiro: Parceiro;

    constructor() {

    }
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/configuracaoVisual.ts